import {Badge, Button, Col, Form, message, Modal, Row, Select, theme} from "antd";
import {useStore} from "../contexts/AppContext";
import {accessRequestForm, statusObj} from "../utils/constants";
import TextArea from "antd/es/input/TextArea";
import api from "../http";
import {useParams} from "react-router-dom";
import {modalThemeConstants} from "../utils/modalThemeConstants";
import {onRemoveRequest} from "../utils/onRemoveRequest";


const AccessRequestForm = () => {
    const {setIsForbidden, requestAccessData, setRequestAccessData, accessResponses, setAccessResponses} = useStore()
    const [form] = Form.useForm();
    const {token} = theme.useToken();
    const {documentId} = useParams();


    const onAccessRequestOk = async () => {
        try {
            const values = await form.validateFields();
            let response

            if (requestAccessData.access_form_mode === 'createNew' || requestAccessData.access_form.status === "rejected") {
                const apiResponse = await api.post('support/create-access-request', {...values, document_id: documentId || requestAccessData.document_id, permission_key: "DOCUMENT_SHARE"})
                if (apiResponse.status === 200) {
                    response = apiResponse.data
                }
            }
            else if (requestAccessData.access_form_mode === 'editOld' && requestAccessData.access_form.status === "pending") {
                const apiResponse = await api.put('support/edit-access-request', {...values, document_id: documentId || requestAccessData.document_id, permission_key: "DOCUMENT_SHARE"})
                if (apiResponse.status === 200) {
                    response = apiResponse.data
                }
            }

            message.success(response.message, 5)
            setIsForbidden(true)
            setRequestAccessData((prevPage => ({
                ...prevPage,
                access_form_modal: false,
                access_form_mode: 'createNew',
                access_form: response.accessRequest
            })))

            setAccessResponses(prevState =>
                prevState.map(doc =>
                    doc.id === response.accessRequest.id
                        ? { ...doc,
                            status: response.accessRequest.status,
                            role_id: response.accessRequest.role_id,
                            role_title: response.accessRequest.role_title,
                            comment: response.accessRequest.comment
                }
                        : doc
                )
            );


        } catch (e) {
            message.error(
                e?.response?.data?.message?.includes("idx_user_req_access_unique_pending")
                    ? "Request pending...👀"
                    : e?.response?.data?.message || "Fill in the required fields"
            );

        }
    }


    const onCancelRequestForm = () => {
        if (requestAccessData.access_accept_access_mode === "request") {
            setIsForbidden(true)
        }
        setRequestAccessData((prevPage => ({
            ...prevPage,
            access_form_modal: false
        })))
    }


    const onDecisionRequest = async (status) => {
        try {
            const values = await form.validateFields();
            const response = await api.put(`support/decision-access-request/${requestAccessData.document_id}`,
                {
                    ...values,
                    status: status,
                    requester_id: requestAccessData.requester_id,
                    requester_email: requestAccessData.requester_email,
                })
            if (response.status === 200) {
                setAccessResponses(prevState =>
                    prevState.map(doc =>
                        doc.id === response.data.accessRequest.id
                            ? { ...doc, status: response.data.accessRequest.status }
                            : doc
                    )
                );
                setRequestAccessData((prevPage => ({
                    ...prevPage,
                    access_form_modal: false
                })))
            }
        } catch (e) {
            message.error(e.response.data.message)
        }
    }


    const footer_request = () => {
        return [
            <Button
                disabled={requestAccessData.access_form?.status === 'rejected'}
                key="decline"
                type="primary"
                danger
                onClick={() =>
                    onRemoveRequest(
                        setRequestAccessData,
                        setIsForbidden,
                        documentId ? documentId : requestAccessData.document_id,
                        accessResponses,
                        setAccessResponses,
                        requestAccessData.access_form.id
                    )}
            >
                Remove
            </Button>,
            <Button key="cancel" onClick={onCancelRequestForm}>
                Cancel
            </Button>,
            <Button key="submit" type="primary" onClick={onAccessRequestOk}>
                Submit
            </Button>
        ]
    }

    const footer_decision = () => {
        return [
            <Button
                key="rejected"
                type="primary"
                danger
                onClick={() => onDecisionRequest("rejected")}
            >
                Reject
            </Button>,
            <Button key="cancel" onClick={onCancelRequestForm}>
                Cancel
            </Button>,
            <Button key="approve" type="primary" onClick={() => onDecisionRequest("approved")}>
                Approve
            </Button>
        ]
    }

    return (
        <Modal
            styles={modalThemeConstants(token)}
            title={requestAccessData.access_accept_access_mode === "request" ? "Form for access request" : "Decision"}
            closable={{'aria-label': 'Custom Close Button'}}
            open={requestAccessData.access_form_modal}
            onCancel={onCancelRequestForm}
            onOk={onAccessRequestOk}
            footer={requestAccessData.access_accept_access_mode === "request" ? footer_request() : footer_decision()}
            afterOpenChange={(open) => {
                if (open && requestAccessData.access_form) {
                    form.setFieldsValue({
                        role_id: requestAccessData.access_form.role_id || null,
                        comment: requestAccessData.access_form.comment || '',
                    });
                }
            }}

        >
            <Form
                form={form}
                layout="vertical"
                initialValues={accessRequestForm}
            >
                <Row gutter={16}>
                    <Col span={24}>
                        <Form.Item
                            name="role_id"
                            label="Choose role"
                            rules={[{required: true, message: 'Please put title'}]}
                        >
                            <Select
                                style={{width: "100%"}}
                                options={[
                                    {value: 4, label: 'Viewer'},
                                    {value: 3, label: 'Editor'},
                                ]}
                            />
                        </Form.Item>
                    </Col>
                    {requestAccessData.access_accept_access_mode === "request" &&
                        <Col span={24}>
                            <Form.Item
                                name="comment"
                                label="Type reason"
                            >
                                <TextArea rows={4}/>
                            </Form.Item>
                        </Col>
                    }

                </Row>
            </Form>
            {requestAccessData.access_form.status &&
                <>
                    <p>Review status - {requestAccessData.access_form.status} <Badge status={statusObj[requestAccessData.access_form.status]}/></p>
                </>
            }
        </Modal>
    )
}


export default AccessRequestForm;